const ISO_DATE_REGEX = /^\d{4}-\d{2}(-\d{2})?(T\d{2}:\d{2}:\d{2})?$/;

export default function formatCellValue(value) {
  if (value == null) return '';
  const str = String(value);
  if (!ISO_DATE_REGEX.test(str)) return str;

  // Handle YYYY-MM format (e.g., "2025-11") by appending day
  // Append T00:00:00 to date-only strings so they parse as local time, not UTC
  let normalized = /^\d{4}-\d{2}$/.test(str) ? `${str}-01` : str;
  if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
    normalized = `${normalized}T00:00:00`;
  }
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return str;

  if (/^\d{4}-\d{2}$/.test(str)) {
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export { ISO_DATE_REGEX };
